import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=1dae5afc&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dae5afc')) {
      api.createRecord('1dae5afc', component.options)
    } else {
      api.reload('1dae5afc', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=1dae5afc&", function () {
      api.rerender('1dae5afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bfTI6yxuoN0p/JS/comp/FavElement.vue"
export default component.exports